var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaming(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133.9 131.73",
    style: {
      enableBackground: "new 0 0 133.9 131.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.46,119.46c-29.41,0-53.33-23.92-53.33-53.33S37.05,12.8,66.46,12.8s53.33,23.92,53.33,53.33 S95.86,119.46,66.46,119.46z M66.46,16.8c-27.2,0-49.33,22.13-49.33,49.33s22.13,49.33,49.33,49.33s49.33-22.13,49.33-49.33 S93.66,16.8,66.46,16.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "73.41,1 73.41,51.82 66.46,56.2 59.5,51.82 59.5,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "59.5,131.26 59.5,80.44 66.46,76.06 73.41,80.44 73.41,131.26  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.33,59.18 52.14,59.18 56.53,66.13 52.14,73.08 1.33,73.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "131.58,73.08 80.77,73.08 76.38,66.13 80.77,59.18 131.58,59.18  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaming);
export default __webpack_public_path__ + "static/media/gaming.d84623d478f016d24f3eafc244b1202a.svg";
export { ForwardRef as ReactComponent };